import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["overlay", "content"]

    connect() {
        this.onKeydown = this.onKeydown.bind(this)
        document.addEventListener("keydown", this.onKeydown);
    }

    disconnect() {
        document.removeEventListener("keydown", this.onKeydown);
    }

    close() {
        this.element.remove();
    }

    backdropClick(event) {
        if (!this.contentTarget.contains(event.target)) {
            this.close();
        }
    }

    onKeydown(event) {
        if (event.key === "Escape") {
            this.close()
        }
    }
}
